var _excluded = ["asSymbol"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from "react";
var CkIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      asSymbol
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return asSymbol ? /*#__PURE__*/React.createElement("symbol", _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref
  }));
});
export default CkIcon;